import classNames from "classnames";
import styles from "./empty-state.module.scss";

type Props = {
  text: string;
  className?: string;
};

export const EmptyState = ({ text, className }: Props) => {
  return (
    <div className={classNames(styles.emptyState, className)}>
      <p className={styles.text}>{text}</p>
    </div>
  );
};
